













export default {
    name: 'BaseLoadingAnimation',
    components: {},
    props: {},
    data() {
        return {};
    },
    methods: {},
};
